module.exports = __webpack_public_path__ + "img/data_science.fe9878ea.webp";